import script from "./EntryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryPage.vue?vue&type=script&setup=true&lang=js"

import "./EntryPage.vue?vue&type=style&index=0&id=55fba3fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55fba3fa"]])

export default __exports__